import React from "react";
import ReactDOM from "react-dom";
import store from "./app/store";
import { Provider } from "react-redux";
import Router from "./routes/router";
import { GlobalStyle } from "./styles/global.style";
import { FeatureProvider } from "./common/featureFlags/FeatureProvider";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

ReactDOM.render(
  <Provider store={store}>
    <FeatureProvider>
      <GlobalStyle />
      <Router />
    </FeatureProvider>
  </Provider>,
  document.getElementById("root")
);
